<hub-modal-form-header title="Delete Media?" (close)="bsModalRef.hide()">
</hub-modal-form-header>
<div class="modal-body">
  <p>Are you sure you wish to delete {{media.Title}}?</p>
  <hub-modal-form-footer saveText="Delete" saveBtnClass="button-assertive" [requiredNote]="false"
    [errorMessage]="serverError" [inProgress]="saveInProgress" (submit)="onSubmit()" (close)="bsModalRef.hide()">
  </hub-modal-form-footer>
</div>